const N = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCAgZD0iTTE0LjU4NiAxMkw3LjI5MyA0LjcwN2wxLjQxNC0xLjQxNEwxNy40MTQgMTJsLTguNzA3IDguNzA3LTEuNDE0LTEuNDE0eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  N as default
};
//# sourceMappingURL=arrow_right-c981611a.mjs.map
